@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row[dataProperty]) {
    <div class="flex align-items-center">
      <span
        [ngClass]="renderClass($.row[$.adata.keyName])"
        class="border-circle mr-2 p-1"
      ></span>
      <span
        >{{ 'TRANSFER.STATUS.' + $.row[$.adata.keyName] | translate }}
      </span>
    </div>
  }
}
